export const Blue = (
    <svg fill="currentColor" height="26" width="26">
        <path d="M0 6.277h25.108v6.277H0zM0 18.83h25.108v6.278H0z" />
    </svg>
);
